import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.667 2.667H3.333a2 2 0 0 0-2 2v6.666a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2V4.667a2 2 0 0 0-2-2M3.333 4h9.334a.667.667 0 0 1 .666.667L8 7.92 2.667 4.667A.667.667 0 0 1 3.333 4m10 7.333a.667.667 0 0 1-.666.667H3.333a.667.667 0 0 1-.666-.667V6.187l4.986 3.046a.67.67 0 0 0 .667 0l5.013-3.046z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })